import { HUD } from "./hud/HUD";
import { GUI } from "./GUI";
import { BoardContainer } from "./BoardContainer";
import { Block } from "./Block";
import { Background } from "./Background";
import { PauseLayer } from "./PauseLayer";
import { RulesLayer } from "./rules-layer/RulesLayer";
import { AudioManager } from "../../AudioManager";
import { GameManager } from "../../GameManager";
import { BoardManager } from "./BoardManager";
import { DestroyBlocksLayer } from "./DestroyBlocksLayer";
import { GameOverLayer } from "./GameOverLayer";

export class BoardScene extends Phaser.Scene {

    public static currentInstance: BoardScene;

    public audioSprite: any;
    public gui: GUI;
    
    private hud: HUD;
    private boardContainer: BoardContainer;
    private boardManager: BoardManager;
    private pauseLayer: PauseLayer;
    private rulesLayer: RulesLayer;
    private background: Background;
    private destroyBlocksLayer: DestroyBlocksLayer;
    private gameOverLayer: GameOverLayer;

    constructor() {

        super("BoardScene");
        
        BoardScene.currentInstance = this;
    }

    public create(): void {

        GameManager.setCurrentScene(this);

        this.createAnimations();

        this.background = new Background(this);
        this.add.existing(this.background);

        this.hud = new HUD(this);
        this.add.existing(this.hud);

        this.gui = new GUI(this);
        this.add.existing(this.gui);

        this.boardContainer = new BoardContainer(this);
        this.add.existing(this.boardContainer);

        this.input.on("pointerup", this.onPointerUp, this);
        this.boardManager = new BoardManager();
        
        AudioManager.playSound("templok_soundtrack", true);

        this.cameras.main.fadeIn(450, 9, 29, 53);
    }

    public update(): void {
        
        this.hud.update();
        this.gui.update();

        if (this.boardManager) {
            this.boardManager.update();
        }
       
        this.boardContainer.update();

        if (this.rulesLayer) {
            this.rulesLayer.update();
        }

        if (this.destroyBlocksLayer) {
            this.destroyBlocksLayer.update();
        }

        this.background.update();
    }

    public onLeaderBoardAssetsLoaded(): void {

        // TODO: BORRAR ESTO
    }

    public startGame(): void {
       
        this.gui.onGameStarted();
        this.hud.onGameStarted();
        this.boardContainer.onGameStarted();    
    }

    public pause(): void {
        
        this.pauseLayer = new PauseLayer(this);
        this.add.existing(this.pauseLayer);
    }

    public resume(): void {
        
        this.pauseLayer.destroy();
    }

    public onBlockFitting(block: Block, blockPosition: {c: number, r: number}): void {
       
        this.boardContainer.addBlock(block, blockPosition);

        this.hud.updateScore();
    }

    public showRules(): void {

        this.pauseLayer.visible = false;

        this.rulesLayer = new RulesLayer(this);
        this.add.existing(this.rulesLayer);
    }

    public removeRules(): void {

        this.pauseLayer.visible = true;

        this.rulesLayer.destroy();
        this.rulesLayer = null;
    }

    public onMatch(rows: number[], columns: number[], duplicatedCellsData: {p: {c: number, r: number}, type: number}[], comboPoints: number): void {

        if (comboPoints > 0) {

            this.hud.onCombo(rows.length + columns.length, comboPoints);
        } 

        this.boardContainer.onMatch(rows, columns, duplicatedCellsData);
    }

    public onGameOver(): void {

        this.boardContainer.onGameOver();

        this.time.delayedCall(1000, function(): void {
            this.gameOverLayer = new GameOverLayer(this);
            this.add.existing(this.gameOverLayer);
        }, [], this);

        AudioManager.playSound("gameover");
        AudioManager.playSound("loop_gameover", true);
    }

    public onBoosterPurchased(): void { 

        this.gameOverLayer.destroy();

        this.gui.onBoosterPurchased();
    }

    public isTimeToDestroyBlocks(): boolean {
        
        if (this.destroyBlocksLayer) {
            return true;
        }
        return false;
    }

    private onPointerUp(): void {
        
        this.boardManager.onPointerUp();
    }

    private createAnimations(): void {

        this.anims.create({ key: "shine", frames: this.anims.generateFrameNames( "texture_atlas_1", {prefix: "glare_", start: 1, end: 21, zeroPad: 2, suffix: ""}), frameRate: 24, hideOnComplete: true, skipMissedFrames: false});
        this.anims.create({ key: "fish_1", frames: this.anims.generateFrameNames( "texture_atlas_2", {prefix: "fish_1_", start: 1, end: 7, zeroPad: 2, suffix: ""}), frameRate: 10, repeat: -1, skipMissedFrames: false});
        this.anims.create({ key: "fish_2", frames: this.anims.generateFrameNames( "texture_atlas_2", {prefix: "fish_2_", start: 1, end: 7, zeroPad: 2, suffix: ""}), frameRate: 10, repeat: -1, skipMissedFrames: false});
        this.anims.create({ key: "fish_3", frames: this.anims.generateFrameNames( "texture_atlas_2", {prefix: "fish_3_", start: 1, end: 7, zeroPad: 2, suffix: ""}), frameRate: 10, repeat: -1, skipMissedFrames: false});
    }
}
